/** Permiso efectivo de GET /importacion/stock. No habilita consultas argentinas. */
export const IMPORTACION_CONSULTAR = 'Importacion.Consultar';

export const VERIFICACION_CONSULTAR =
	'Importacion.VerificacionIngreso.Consultar';
export const VERIFICACION_SOLICITAR =
	'Importacion.VerificacionIngreso.RegistrarSolicitud';
export const VERIFICACION_ATENDER =
	'Importacion.VerificacionIngreso.AtenderSolicitud';
export const VERIFICACION_RESOLVER =
	'Importacion.VerificacionIngreso.RegistrarAuditoria';

export const IMPORTACION_GESTIONAR = 'Importacion.Gestionar';
